<template>
  <div class="card">
    <img
      :src="image"
      :alt="title"
      class="card-img"
    />
    <div class="card-body">
      <h3 class="card-title">
        {{ title }}
      </h3>
      <p class="card-text">
        {{ description }}
      </p>

      <button
        @click="handleOrderClick"
        class="btn-outline-primary card-cta"
        style="font-family: 'Cormorant SC', serif;"
      >
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</template>

<script>
import { getAuth } from "firebase/auth";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { createCartItem } from "@/utils/homepageToMenuMapping";

export default {
  name: "CardDish",
  props: {
    image: String,
    title: String,
    description: String,
    buttonLabel: { type: String, default: "Order Now" },
    titleKey: { type: String, default: null },
    addToCart: { type: Function, default: null }
  },
  setup(props) {
    const auth = getAuth();
    const router = useRouter();
    const { t } = useI18n();

    const handleOrderClick = () => {
      const user = auth.currentUser;

      if (user && user.emailVerified) {
        if (props.addToCart && props.titleKey) {
          const cartItem = createCartItem(props.titleKey, { t });
          if (cartItem) {
            props.addToCart(cartItem);
          }
        }
        router.push("/menu");
      } else {
        router.push("/login?redirect=/menu");
      }
    };

    return { handleOrderClick };
  }
};
</script>

<style scoped>
.card {
  background: var(--card-bg);
  color: var(--card-text);
  transition: background-color .2s ease;
  box-shadow: var(--card-shadow);
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  border-radius: var(--card-radius);
}

.card:hover {
  background: var(--card-bg-hover);
}

.card-img {
  width: 100%;
  height: 11rem;           /* ~ h-44 */
  object-fit: cover;
  border-radius: var(--card-radius);
}

@media (min-width: 768px) {
  .card-img { height: 12rem; } /* ~ md:h-48 */
}

.card-body {
  padding: 1.5rem;         /* p-6 */
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  text-align: center;
}

.card-title {
  font-weight: 700;
  font-size: clamp(.875rem, 2vw, 1.125rem); /* sm->md sizes */
  margin: 0 0 .25rem 0;
  color: var(--on-surface);
}

.card-text {
  font-size: clamp(.75rem, 2vw, 1rem);
  color: var(--card-muted);
}

/* CTA button inherits shared outline-primary look */
.btn-outline-primary {
  color: var(--primary);
  border: 2px solid var(--primary);
  background: transparent;
  box-shadow: var(--glow-sm);
  transition: background .2s, color .2s, box-shadow .2s;
}

.btn-outline-primary:hover {
  background: var(--primary);
  color: var(--on-primary);
}

.card-cta {
  margin-top: auto;
  padding: .5rem 1.25rem; /* px-5 py-2 */
  font-weight: 600;
  font-size: clamp(.75rem, 2vw, 1.125rem);
  border-radius: var(--card-radius);
}
</style>
